// ISO 3166-1 alpha-2 country codes; labels localized with Intl.DisplayNames.
export const COUNTRY_CODES = [
  "AF", "ZA", "AL", "DZ", "DE", "AD", "AO", "AR", "AM", "AU", "AT", "BE", "BJ", "BY", "BO", "BA",
  "BW", "BR", "BG", "BF", "BI", "KH", "CM", "CA", "CV", "CF", "CL", "CN", "CY", "CO", "KM", "CG",
  "CD", "KR", "CR", "CI", "HR", "CU", "DK", "DJ", "EG", "AE", "EC", "ER", "ES", "EE", "US", "ET",
  "FI", "FR", "GA", "GM", "GE", "GH", "GR", "GT", "GN", "GW", "GQ", "HT", "HN", "HU", "IN", "ID",
  "IQ", "IR", "IE", "IS", "IL", "IT", "JM", "JP", "JO", "KZ", "KE", "KG", "LA", "LS", "LV", "LB",
  "LR", "LY", "LT", "LU", "MG", "MY", "MW", "ML", "MT", "MA", "MU", "MR", "MX", "MD", "MC", "MN",
  "ME", "MZ", "NA", "NE", "NG", "NI", "NO", "NZ", "OM", "UG", "UZ", "PK", "PA", "PG", "PY", "NL",
  "PE", "PH", "PL", "PT", "QA", "RO", "GB", "RU", "RW", "SV", "SN", "RS", "SL", "SG", "SK", "SI",
  "SO", "SD", "SS", "SE", "CH", "SR", "SY", "TJ", "TZ", "TD", "CZ", "TH", "TG", "TN", "TM", "TR",
  "UA", "UY", "VE", "VN", "YE", "ZM", "ZW",
];

export const countryLabel = (code, lang) => {
  if (!code) return "";
  try { return new Intl.DisplayNames([lang || "fr"], { type: "region" }).of(code) || code; }
  catch { return code; }
};

export const countryList = (lang) => {
  let dn;
  try { dn = new Intl.DisplayNames([lang || "fr"], { type: "region" }); }
  catch { dn = new Intl.DisplayNames(["fr"], { type: "region" }); }
  return COUNTRY_CODES
    .map((code) => ({ code, label: dn.of(code) || code }))
    .sort((a, b) => a.label.localeCompare(b.label, lang || "fr"));
};

// International dialing codes (E.164) keyed by ISO 3166-1 alpha-2.
export const DIAL_CODES = {
  AF: "93", ZA: "27", AL: "355", DZ: "213", DE: "49", AD: "376", AO: "244", AR: "54",
  AM: "374", AU: "61", AT: "43", BE: "32", BJ: "229", BY: "375", BO: "591", BA: "387",
  BW: "267", BR: "55", BG: "359", BF: "226", BI: "257", KH: "855", CM: "237", CA: "1",
  CV: "238", CF: "236", CL: "56", CN: "86", CY: "357", CO: "57", KM: "269", CG: "242",
  CD: "243", KR: "82", CR: "506", CI: "225", HR: "385", CU: "53", DK: "45", DJ: "253",
  EG: "20", AE: "971", EC: "593", ER: "291", ES: "34", EE: "372", US: "1", ET: "251",
  FI: "358", FR: "33", GA: "241", GM: "220", GE: "995", GH: "233", GR: "30", GT: "502",
  GN: "224", GW: "245", GQ: "240", HT: "509", HN: "504", HU: "36", IN: "91", ID: "62",
  IQ: "964", IR: "98", IE: "353", IS: "354", IL: "972", IT: "39", JM: "1", JP: "81",
  JO: "962", KZ: "7", KE: "254", KG: "996", LA: "856", LS: "266", LV: "371", LB: "961",
  LR: "231", LY: "218", LT: "370", LU: "352", MG: "261", MY: "60", MW: "265", ML: "223",
  MT: "356", MA: "212", MU: "230", MR: "222", MX: "52", MD: "373", MC: "377", MN: "976",
  ME: "382", MZ: "258", NA: "264", NE: "227", NG: "234", NI: "505", NO: "47", NZ: "64",
  OM: "968", UG: "256", UZ: "998", PK: "92", PA: "507", PG: "675", PY: "595", NL: "31",
  PE: "51", PH: "63", PL: "48", PT: "351", QA: "974", RO: "40", GB: "44", RU: "7",
  RW: "250", SV: "503", SN: "221", RS: "381", SL: "232", SG: "65", SK: "421", SI: "386",
  SO: "252", SD: "249", SS: "211", SE: "46", CH: "41", SR: "597", SY: "963", TJ: "992",
  TZ: "255", TD: "235", CZ: "420", TH: "66", TG: "228", TN: "216", TM: "993", TR: "90",
  UA: "380", UY: "598", VE: "58", VN: "84", YE: "967", ZM: "260", ZW: "263",
};

export const dialCode = (code) => DIAL_CODES[code] || "";

// Countries that have a dialing code, sorted by localized label — for phone pickers.
export const dialCodeList = (lang) =>
  countryList(lang)
    .map((c) => ({ ...c, dial: DIAL_CODES[c.code] || "" }))
    .filter((c) => c.dial);

